// extracted by mini-css-extract-plugin
module.exports = {"cls1":"contacts-Copyright-module--cls1--321S5","cls2":"contacts-Copyright-module--cls2--251il contacts-Copyright-module--cls1--321S5"};